<template>
    <v-page-data-table
            title="模板管理"
            key-name="id"
            :fields="fields"
            ref="template"
            @create="onDetail"
            :show-edit="false"
            :row-actions="rowActions"
            :toolbar-actions="toolActions"
            delete-api="TEMPLATE_DELETE"
            query-api="TEMPLATE_QUERY">

        <template v-slot:name="{item}">
            <v-link-text :text="item.name" @click="onDetail(item)"></v-link-text>
        </template>

        <template v-slot:templateFileName="{item}">
            <v-link-text :text="item.templateFileName" @click="download(item)"></v-link-text>
        </template>
    </v-page-data-table>
</template>

<script>
    import TemplateQueryFields from "./fields/TemplateQueryFields";

    export default {
        name: "TemplateQuery",
        data() {
            return {
                fields: TemplateQueryFields,
                rowActions: [],
                toolActions: [
                    {
                        text: '新建模板',
                        color: 'primary',
                        icon: "mdi-plus-circle",
                        action: 'create'
                    }
                ]
            }
        },
        methods: {
            onDetail(item) {
                let id = item ? item.id : undefined;
                this.$router.apmRoute("templateDetail", {id: id});
            },
            viewImage(url) {
                window.open(url, '_blank');
            },
            download(item) {
                window.open(item.templateFileUrl, '_blank');
            }
        }
    }
</script>
